var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "el-form",
                {
                  attrs: { inline: "", size: "small", "label-width": "120px" },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "蛋糕名称：" } },
                    [
                      _c(
                        "el-input",
                        {
                          staticClass: "selWidth",
                          attrs: {
                            placeholder: "蛋糕名称",
                            size: "small",
                            clearable: "",
                          },
                          model: {
                            value: _vm.listPram.name,
                            callback: function ($$v) {
                              _vm.$set(_vm.listPram, "name", $$v)
                            },
                            expression: "listPram.name",
                          },
                        },
                        [
                          _c("el-button", {
                            attrs: {
                              slot: "append",
                              icon: "el-icon-search",
                              size: "small",
                            },
                            on: { click: _vm.handerSearch },
                            slot: "append",
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品来源：" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: { clearable: "", placeholder: "请选择" },
                          on: {
                            change: function ($event) {
                              return _vm.handerSearch(0)
                            },
                          },
                          model: {
                            value: _vm.listPram.source,
                            callback: function ($$v) {
                              _vm.$set(_vm.listPram, "source", $$v)
                            },
                            expression: "listPram.source",
                          },
                        },
                        _vm._l(_vm.FROM_TYPE_OPTIONS, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品品牌：" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth ",
                          attrs: {
                            clearable: "",
                            placeholder: "请选择",
                            filterable: "",
                            "filter-method": _vm.handleAgreementSearch,
                          },
                          on: { change: _vm.handerSearch },
                          model: {
                            value: _vm.listPram.brandId,
                            callback: function ($$v) {
                              _vm.$set(_vm.listPram, "brandId", $$v)
                            },
                            expression: "listPram.brandId",
                          },
                        },
                        _vm._l(_vm.brandOption, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.brandStr, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticStyle: { "margin-top": "20px", display: "flex" } },
                [
                  _c("async-export-button", {
                    attrs: {
                      type: "cake_product",
                      params: _vm.cakeExportParams,
                      "button-text": "导出结果",
                      "button-type": "primary",
                      "show-progress-dialog": true,
                      "button-style": { marginLeft: "0", marginRight: "10px" },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "ButtonUploadExcel",
                    {
                      staticClass: "mr10",
                      attrs: {
                        beforeUpload: function (file) {
                          return _vm.beforeUpload(file, "importUpdatePriceCake")
                        },
                      },
                    },
                    [_vm._v("导入修改")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "mr10",
                      attrs: { type: "primary" },
                      on: { click: _vm.importSelf },
                    },
                    [_vm._v("导入关联自营")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "mr10",
                      attrs: { type: "primary" },
                      on: { click: _vm.asyncGoods },
                    },
                    [_vm._v("同步福司令蛋糕")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "table",
              attrs: {
                data: _vm.listData.list,
                size: "mini",
                "highlight-current-row": "",
                "header-cell-style": { fontWeight: "bold" },
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "productId",
                  label: "商品ID",
                  "min-width": "80",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "id", label: "skuID", "min-width": "80" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "skuId", label: "关联ID", "min-width": "80" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "主图", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.abbreviationImage
                          ? _c(
                              "div",
                              { staticClass: "demo-image__preview" },
                              [
                                _c("el-image", {
                                  staticStyle: {
                                    width: "36px",
                                    height: "36px",
                                  },
                                  attrs: {
                                    src: scope.row.abbreviationImage,
                                    "preview-src-list": [
                                      scope.row.abbreviationImage,
                                    ],
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "name",
                  label: "蛋糕名称",
                  "min-width": "160",
                  "show-overflow-tooltip": true,
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "brandName",
                  label: "品牌名称",
                  "min-width": "160",
                  "show-overflow-tooltip": true,
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "size",
                  label: "尺寸",
                  "min-width": "80",
                  "show-overflow-tooltip": true,
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "weight",
                  label: "重量",
                  "min-width": "80",
                  "show-overflow-tooltip": true,
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "bidPrice",
                  label: "结算价",
                  "min-width": "80",
                  "show-overflow-tooltip": true,
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "defaultPrice",
                  label: "默认售价",
                  "min-width": "120",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-input", {
                          attrs: { size: "mini" },
                          on: {
                            blur: function ($event) {
                              return _vm.changeCakePrice(scope.row)
                            },
                          },
                          model: {
                            value: scope.row.defaultPrice,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "defaultPrice", $$v)
                            },
                            expression: "scope.row.defaultPrice",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "status", label: "是否展示" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-switch", {
                          attrs: { "active-value": 1, "inactive-value": 0 },
                          on: {
                            change: function ($event) {
                              return _vm.onchangeIsShow(scope.row)
                            },
                          },
                          model: {
                            value: scope.row.status,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "status", $$v)
                            },
                            expression: "scope.row.status",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "sellPrice",
                  label: "第三方建议售价",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "usedToEat",
                  label: "适用人数",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "labels", label: "标签", "min-width": "100" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return scope.row &&
                          scope.row.labels &&
                          scope.row.labels.length
                          ? _c("div", {}, [
                              _vm._v(_vm._s(scope.row.labels.join("、"))),
                            ])
                          : _vm._e()
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "source", label: "来源", "min-width": "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _c("div", {}, [
                        _vm._v(
                          _vm._s({ 1: "自营", 2: "福司令" }[scope.row.source])
                        ),
                      ])
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  "min-width": "180",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            staticClass: "mr10",
                            attrs: { size: "small", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.editDgGood(scope.row.productId)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "mr10",
                            attrs: { size: "small", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handlerDelete(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "mr10",
                            attrs: { size: "small", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.bindTag(scope.row.productId)
                              },
                            },
                          },
                          [_vm._v("打标")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.listPram.page,
              "page-sizes": _vm.constants.page.limit,
              layout: _vm.constants.page.layout,
              total: _vm.listData.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("SendPintuan", {
        ref: "SendPintuanRef",
        on: { doRefresh: _vm.handerSearch },
      }),
      _vm._v(" "),
      _c("PintuanCreate", { ref: "PintuanCreateRef" }),
      _vm._v(" "),
      _c("BindImport", {
        ref: "BindImportRef",
        on: { doRefresh: _vm.handerSearch },
      }),
      _vm._v(" "),
      _c("SyncProduct", {
        ref: "SyncProductRef",
        on: { doRefresh: _vm.handerSearch },
      }),
      _vm._v(" "),
      _c("BindcakeTag", {
        ref: "BindcakeTagRef",
        on: { doRefresh: _vm.handerSearch },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }